import React from "react";

const DotsVerticalIcon = ({ fill = "rgba(112, 112, 112, 1)" }) => (
  <svg width="20" height="20" viewBox="0 0 20 20">
    <circle cx="10" cy="4" r="2" fill={fill} />
    <circle cx="10" cy="10" r="2" fill={fill} />
    <circle cx="10" cy="16" r="2" fill={fill} />
  </svg>
);

export default DotsVerticalIcon;
